import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import IKanbanBoardProductionSchemaProps from "../../../Components/KanbanBoardProduction/interfaces/kanban-board-production-schema.interface";
import { useToast } from "../../../Hooks/ToasContext";
import { IServiceOrderEntity, IUpdateServiceOrdersPayload, ServiceOrderStatusEnum } from "../../../Services/api/service-orders/service-order.interface";
import { ListServiceOrdersUseCase } from "../../../Usecase/ServiceOrders/list-service-orders-usecase";
import { ShowServiceOrdersUseCase } from "../../../Usecase/ServiceOrders/show-service-orders-usecase";
import { UpdateServiceOrdersUseCase } from "../../../Usecase/ServiceOrders/update-service-orders-usecase";
import { Task } from "../../Financial/Details/financial-details.hook";


interface IUseListProductionProps {
  listServiceOrdersUseCase: ListServiceOrdersUseCase
  showServiceOrdersUseCase: ShowServiceOrdersUseCase
  updateServiceOrdersUseCase: UpdateServiceOrdersUseCase
}
export function useListProduction({ listServiceOrdersUseCase, showServiceOrdersUseCase, updateServiceOrdersUseCase }: IUseListProductionProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<any[]>([])
    const [tabValue, setTabValue] = useState(0)
    const [productionTypeView, setProductionTypeView] = useState('0')
    const [totalRegisters, setTotalRegisters] = useState(1)
    const navigate = useNavigate()
    const [kanbanSchema, setKanbanSchema] = useState<IKanbanBoardProductionSchemaProps>()
    const [orderDetails, setOrderDetails] = useState<IServiceOrderEntity | undefined>()

    const { showToast } =  useToast()

    const transformData = (dados: IServiceOrderEntity[]) => {
      
      const tasks: Record<string, Task> = {};
      const initialOS : any = [];
      const onProductionOS : any = [];
      const finishsedOS : any = [];
      
      dados.forEach((item, index) => {
          // const taskId = `task-${index + 1}`;
          const taskId = item.id;
          tasks[taskId] = {
              id: taskId,
              content: {
                  os: `OS #${item.externalProductionId}`,
                  items: item.products
              }
          };

          // if(item.status === ServiceOrderStatusEnum.INITIAL){
          //   initialOS.push(taskId);
          // } else if ([ServiceOrderStatusEnum.PROCESSING, ServiceOrderStatusEnum.PREPRINT, ServiceOrderStatusEnum.PRINT, ServiceOrderStatusEnum.CUT_AND_VINCO_AUTO, ServiceOrderStatusEnum.CUT_AND_VINCO_MANUAL, ServiceOrderStatusEnum.HIGHLIGHT, ServiceOrderStatusEnum.IN_MACHINE, ServiceOrderStatusEnum.LAMINATION, ServiceOrderStatusEnum.FEATURED, ServiceOrderStatusEnum.WATER_TO_FINISH].includes(item.status)){
          //   onProductionOS.push(taskId)
          // } else if ([ServiceOrderStatusEnum.BILLED, ServiceOrderStatusEnum.PRODUCED].includes(item.status)){ 
          //   finishsedOS.push(taskId)
          // }
          if(item.status === ServiceOrderStatusEnum.INITIAL){
            initialOS.push(taskId);
          } else if (Object.entries(item.status)
            .filter(([value]) => ![ServiceOrderStatusEnum.ERROR, ServiceOrderStatusEnum.PRODUCED, ServiceOrderStatusEnum.BILLED].includes(value as ServiceOrderStatusEnum))){
            onProductionOS.push(taskId)
          } else if (Object.entries(item.status)
            .filter(([value]) => [ServiceOrderStatusEnum.PRODUCED, ServiceOrderStatusEnum.BILLED].includes(value as ServiceOrderStatusEnum))){ 
            finishsedOS.push(taskId)
          }
          
      });

      const result = {
          tasks,
          columns: {
            [ServiceOrderStatusEnum.INITIAL]: {
                  id: ServiceOrderStatusEnum.INITIAL,
                  title: 'Aguardando Início',
                  taskIds: initialOS,
              },
              [ServiceOrderStatusEnum.PROCESSING]: {
                  id: ServiceOrderStatusEnum.PROCESSING,
                  title: 'Em Produção',
                  taskIds: onProductionOS,
              },
              [ServiceOrderStatusEnum.PRODUCED]: {
                  id: ServiceOrderStatusEnum.PRODUCED,
                  title: 'Produzido',
                  taskIds: finishsedOS,
              },
          },
          columnOrder: [ServiceOrderStatusEnum.INITIAL, ServiceOrderStatusEnum.PROCESSING, ServiceOrderStatusEnum.PRODUCED],
      };

      return result;
    }

    const listProduction = async ({ page: currentPage, search}: { page : number; search?: string }) => {
        
        try {
          setLoading(true)
          
          const listResult = await listServiceOrdersUseCase.handle(currentPage);

          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()

         const normalizeSchema : IKanbanBoardProductionSchemaProps = transformData(list?.data ?? [])
        
         setKanbanSchema(normalizeSchema)
         setTotalRegisters(list?.total || 0)
         setData(list?.data || [])

        

         setPage(currentPage)
        } catch (error) {
          console.log("error listProduction function: ", error)
        } finally {
          setLoading(false);
        }
      };

    const list = useMemo(() => {
        const rows = data?.map(sale => {

            return {
                ...sale,
                // products: sale.products.map(product => {
                //   return {
                //     ...product,
                     
                //   }
                // })
              
            }
        })

        return rows
    }, [data])

    const handleShowDetails = (code: string) => {
      console.log("code: ", code)
      // setShowDetails(code)
    } 

    const handleConfirmProductionItems = async (e:IUpdateServiceOrdersPayload) => {
      try {

      //   setLoading(true)
        
      //   const updateResult = await updateServiceOrdersUseCase.handle(e)

      //   if (updateResult.isFailure) {
      //     showToast(String(updateResult?.error?.error), 'error');
      //     return;
      //   }

      //  const dados = updateResult.getValue()

        
      //   showToast(String('Itens atualizados'), 'info');
        
      } catch (error) {
        console.log("erro handleConfirmProductionItems: ", error)
      } finally {
        setLoading(false);
      }
    
    }

    const handleShowOrderDetails = async (osId?: string) => {
        
      try {
        setLoading(true)
        
        const listResult = await showServiceOrdersUseCase.handle(String(osId))

        if (listResult.isFailure) {
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const dados = listResult.getValue()

       if(dados){
        setOrderDetails(dados)
       }

  
     
    
      } catch (error) {
        console.log("error listProduction function: ", error)
      } finally {
        setLoading(false);
      }
    };

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
      setTabValue(newValue);
    };

    const handleNavigateDetails = (e: any) => {
      navigate(`/production-details/${e.id}`)
    
    }

    const itemsData = [
      {
          id: '123',
          order_id: '4123',
          customer: 'Diego Hennrich',
          product: 'POTES PERSONALIZADOS 210 ML CARTAO TRIPLEX P1',
          price: 273.98,
          quantity: 500,
          os_number: '41233',
          time: 'Atrasado 51 dias',
          approvation_date: '16/12/2024',
          card: 'P081-210',
          step: 'OS Emitida'
      },
      {
          id: '124',
          order_id: '4124',
          customer: 'Maria Souza',
          product: 'COPOS 300 ML - POLIPROPILENO',
          price: 150.75,
          quantity: 300,
          os_number: '41234',
          time: 'Dentro do prazo',
          approvation_date: '20/12/2024',
          card: 'C300-PP',
          step: 'Em Produção'
      },
      {
          id: '125',
          order_id: '4125',
          customer: 'João Pereira',
          product: 'SACOLAS KRAFT 30X40',
          price: 320.50,
          quantity: 1000,
          os_number: '41235',
          time: 'Atrasado 10 dias',
          approvation_date: '10/12/2024',
          card: 'SK30-40',
          step: 'Impressão'
      },
      {
          id: '126',
          order_id: '4126',
          customer: 'Ana Lima',
          product: 'ETIQUETAS ADESIVAS 5X5 CM',
          price: 95.30,
          quantity: 2000,
          os_number: '41236',
          time: 'Entregue',
          approvation_date: '05/12/2024',
          card: 'EA-5X5',
          step: 'Finalizado'
      },
      {
          id: '127',
          order_id: '4127',
          customer: 'Carlos Mendes',
          product: 'CADERNOS PERSONALIZADOS A5',
          price: 580.90,
          quantity: 150,
          os_number: '41237',
          time: 'Atrasado 3 dias',
          approvation_date: '15/12/2024',
          card: 'CP-A5',
          step: 'Corte e Vinco'
      }
    ];
  

    

      

    return {
        loading,
        listProduction,
        list,
        data,
        handleShowDetails,
        setOrderDetails,
        handleConfirmProductionItems,
        kanbanSchema,
        handleShowOrderDetails,
        orderDetails,
        tabValue,
        handleChangeTab,
        setProductionTypeView,
        productionTypeView,
        totalRegisters,
        handleNavigateDetails,
        itemsData
        
    }
}